import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=2f3c1f06&scoped=true&lang=pug&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=2f3c1f06&scoped=true&lang=stylus&"
import style1 from "./Result.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c1f06",
  null
  
)

component.options.__file = "Result.vue"
export default component.exports